import React from 'react';

function Recommendations({ recommendations }) {
  const items = Array.isArray(recommendations) ? recommendations : [];
  if (items.length === 0) return null;

  return (
    <div style={{ background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16, marginBottom: 24 }}>
      <h3 style={{ color: '#e5e7eb', marginTop: 0, marginBottom: 16, fontSize: 18 }}>Recommendations</h3>
      <div style={{ display: 'grid', gap: 12 }}>
        {items.map((rec, index) => {
          const level = String(rec?.level || 'info').toLowerCase();
          const bg = level === 'critical' ? 'rgba(239, 68, 68, 0.1)' : level === 'warning' ? 'rgba(245, 158, 11, 0.1)' : 'rgba(59, 130, 246, 0.1)';
          const stripe = level === 'critical' ? '#ef4444' : level === 'warning' ? '#f59e0b' : '#3b82f6';

          return (
            <div key={`${level}-${index}`} style={{ background: bg, borderLeft: `4px solid ${stripe}`, padding: '12px 16px', borderRadius: 4 }}>
              <h4 style={{ color: '#e5e7eb', margin: '0 0 4px 0', fontWeight: 500 }}>{rec?.message || 'Recommendation'}</h4>
              {rec?.details && (
                <p style={{ color: '#9ca3af', margin: '0 0 4px 0', fontSize: 14 }}>{rec.details}</p>
              )}
              {rec?.suggestion && (
                <p style={{ color: '#e5e7eb', margin: '8px 0 0 0', fontSize: 14, fontWeight: 500 }}>
                  <span style={{ color: '#9ca3af' }}>Suggestion: </span>
                  {rec.suggestion}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default React.memo(Recommendations);
